if (!window.Eurus.loadedScript.has('cart-noti.js')) {
  window.Eurus.loadedScript.add('cart-noti.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartNoti', {
        enable: false,
        listItem: [],
        show: false,
        setItem(items) {
          this.listItem = [];
          if (items.items) {
            this.listItem = items.items
          } else {
            this.listItem.push(items);
          }
          this.open();
        },
        open() {
          this.show = true;
          clearTimeout(this._hideTimer);
          this._hideTimer = setTimeout(() => {
            this.show = false;
          }, 3000);
        },
        // Single close path for the X button and the auto-hide timer. Kills the
        // pending timer so a late-firing timeout can't race a manual close.
        close() {
          clearTimeout(this._hideTimer);
          this.show = false;
        }
      })
    });
  });
}